import { useCallback, useEffect, useState } from 'react';
import { challengeApi } from '../services/api';
import { interpretMyChurchProgress } from '../utils/churchChallenge';

/**
 * Load the signed-in member's church progress for the active challenge.
 * Single fetch: challengeApi.getMyChurchProgress() → GET /challenges/active/my-church.
 */
export function useMyChurchProgress() {
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const response = await challengeApi.getMyChurchProgress();
      setPayload(response.data);
      setError(null);
    } catch (err) {
      console.error('Failed to load church challenge progress:', err);
      setError('Failed to load church challenge progress. Please try again.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return {
    payload,
    loading,
    error,
    retry: load,
    ...interpretMyChurchProgress(payload)
  };
}
